import React, {createContext} from 'react';
import axios from "../utils/axios";
import { cWarn } from '../components/igtm/CustomLogger';

export const SelectorContext = createContext();

class SelectorContextProvider extends React.Component {

    constructor(props) {
        super(props);

        const {brandContext,profile:{profile}} = props;
        
        this.flag = '';
        let profileFlag = '';
        this.unitAccess = '';
        this.brandContext = brandContext;

        if(brandContext.brand.mode === 'travelCo'){
            this.flag = 'selectedTravelCoId';
            profileFlag = 'travelCos';
            this.unitAccess = 'travelCo';
        }
        if(brandContext.brand.mode === 'fpCo'){
            this.flag = 'selectedFpCoId';
            profileFlag = 'fpCos';
            this.unitAccess = 'fpCo';
        }
        

        

        const obj = {
            isLoading: true,
            unit : false,
            hasOptions: false,
            data:null
        };


        if(profileFlag !== ''){
            const selectedUnitId = localStorage.getItem(this.flag);
            try {
                if (selectedUnitId) {
                    obj.unit = JSON.parse(selectedUnitId);
                } else if (profile[profileFlag].length === 1) {
                    /* eslint-disable */
                    obj.unit = profile[profileFlag][0][this.unitAccess];
                    /* eslint-enable */
                }
                
                if (profile.hasSuperRights || profile[profileFlag].length > 1) {
                    obj.hasOptions = true;
                }
            }
            catch(e){
                console.warn(e);
            }
        }

        this.state=obj;
    }

    
    componentDidMount() {
        if(this.brandContext.brand.mode === 'schoolAdmin'){
            const apiPath = `${process.env.REACT_APP_API_URL}/staffpermissions`;

            axios.get(apiPath,{
                timeout: 30000,
                withCredentials:true
            }).then(res => {
                this.setState({
                    isLoading:false,
                    data:res.data
                })
            }).catch(err => {
                this.setState({
                    isLoading:false,
                })
                cWarn(err);
            });
        }
        else{
            this.setState({isLoading:false});
        }
       
    }
    

    setUnit(unit){
        localStorage.setItem(this.flag,JSON.stringify(unit));
        this.setState({
            unit
        });

    }

    releaseUnit(){
        localStorage.removeItem(this.flag);
        this.setState({
            unit:false
        });
    }



    render() {
        return (
            <SelectorContext.Provider value={{
                ...this.state,
                setUnit:this.setUnit.bind(this),
                releaseUnit:this.releaseUnit.bind(this),
                setState:this.setState.bind(this)
            }}>
                {this.props.children}
            </SelectorContext.Provider>
        );
    }
}

export default SelectorContextProvider;